export function getSidebarTabs({ status, route }) {
  if (!status) return ['LOGS'];

  const tabsByStatus = {
    unassigned: { tabs: ['LOGS'], statuses: pendingStatuses },
    assigned: { tabs: ['LOGS', 'CHAT', 'MAP'], statuses: inTransitStatuses },
    finished: { tabs: ['LOGS', 'CHAT'], statuses: finishedStatuses },
  };

  return Object.values(tabsByStatus).reduce(
    (acc, { statuses, tabs }) => {
      if (statuses.includes(status)) return tabs;
      return acc;
    },
    ['LOGS']
  );
}

export const pendingStatuses = ['PENDING_ASSIGNMENT'];
export const inTransitStatuses = ['ASSIGNED', 'IN_TRANSIT'];
export const finishedStatuses = [
  'DONE_WITHOUT_MANIFEST',
  'DONE',
  'CANCELLED',
  'DONE_WITH_CANCELLATIONS',
];

export const palletsByCountry = {
  UK: 'american',
  default: 'european',
};
